import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Spinner from '../ui/Spinner';

export default function RoleGuard({ allowedRoles, children, fallback = '/dashboard' }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center min-h-[40vh] text-gray-600 gap-3">
        <Spinner size="lg" className="text-primary h-8 w-8" />
        <span className="text-sm">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const roleAllowed =
    allowedRoles.includes(user.role) ||
    (user.role === 'associate' && allowedRoles.includes('setter'));
  if (!roleAllowed) return <Navigate to={fallback} replace />;
  return children;
}